import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { store } from "./app/store";
// import axios from "axios"

// axios.interceptors.response.use((res) => {
//   if(res.data.data?.getToDoList?.status === 401 || res.data.data?.getUserInfo?.status === 401) {
//     console.log("logout")
//   }
//   console.log("interceptors", res)
//   return res;
// })

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
